var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapControlsMask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "86.668808mm",
    height: "58.291855mm",
    viewBox: "0 0 86.668808 58.291855",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-517.68459,-334.73397)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2",
    transform: "matrix(1.6975572,0,0,1.6975572,-212.69053,-156.22253)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g11-0",
    transform: "translate(110.43793,8.5424298)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g15-6",
    transform: "translate(0.16481616,-14.862104)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.321049,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    d: "m 345.24403,295.53319 -2.80879,6.74053 -22.5488,3.58026 -0.23851,24.01788 18.65151,-1.43731 32.4035,1.04529 -0.16689,-33.15993 z",
    id: "path15-9-9"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapControlsMask);
export default __webpack_public_path__ + "static/media/MapControlsMask.6625f49c880ae5d8dbbcaedfaceff8a8.svg";
export { ForwardRef as ReactComponent };